export default {
  zh: {
    title: '线路名称中的简写都表示什么意思？',
    content: [
      '线路名称中的简写一般是网络服务商名称或者表示支持特定的视频平台，常见的有：',
      'HKT：表示该线路的网络服务商是香港电讯',
      'HKBN：表示该线路的网络服务商是香港宽频',
      'APNIC：表示该线路的网络服务商是香港亚太互联',
      'HKCM：表示该线路的网络服务商是香港移动',
      'PCCW：表示该线路的网络服务商是香港电讯盈科',
      'HiNet：表示该线路的网络服务商是台湾中华电信',
      'Softbank：表示该线路的网络服务商是日本软银',
      'Viaplay：表示该线路支持Viaplay视频播放',
      'Netflix：表示该线路支持Netflix视频播放',
      'AbemaTV：表示该线路支持AbemaTV视频播放',
      'Iplayer BBC：表示该线路支持Iplayer BBC视频播放',
      'Relay：表示该线路是中转线路，比如HK Relay，就是从香港中转',
      'BGP IPLC：表示该线路是网络自适应线路'
    ]
  },
  en: {
    title: 'What’s the meaning of abbreviations following servers?',
    content: [
      'Generally, they represent network service providers or certain streaming sites the server can be used to watch. Here are meanings of some common abbreviations:',
      'HKT: the network service provider of this server is Hong Kong Telecom',
      'HKBN: the network service provider of this server is Hong Kong Broadband Network',
      'APNIC: the network service provider of this server is Asia-Pacific Network Information Centre（Hong Kong）',
      'HCM: the network service provider of this server is China Mobile Hong Kong',
      'PCCW: the network service provider of this server is Pacific Century CyberWorks（Hong Kong）',
      'HiNet: the network service provider of this server is Chunghwa Telecom （Taiwan）',
      'Softbank: the network service provider of this server is SoftBank Group',
      'Viaplay: the server can be used to watch Viaplay',
      'Netflix: the server can be used to watch Netflix',
      'AbemaTV: the server can be used to watch AbemaTV',
      'Iplayer BBC: the server can be used to watch Iplayer BBC',
      'Relay: this is a relay server, such as HK Relay which means the server is relayed via Hong Kong',
      'BGP IPLC: the is a network auto-adaptation server'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/views/app/lineDescFAQ/lang.js